<template>
  <div class="pc-page">
    <div class="top-wrap">
      <div class="top">
        <img class="logo" src="./../../../assets/png/pc/logo.png" alt="" />
        <img class="cdn" src="./../../../assets/png/pc/cdn.png" alt="" />
      </div>
    </div>
    <div v-if="showImg">
      <img
        v-for="(item, index) in urlList1"
        :key="index"
        :src="item.url"
        width="1"
        height="1"
        @error="autoTest(item, index)"
        style="display: none"
      />
    </div>
    <div class="container">
      <div class="app-list">
        <div
          :class="['item', 'item' + index]"
          v-for="(item, index) in urlList"
          :key="index"
        >
          <div @click.stop="tolinkUrl(item.url)" class="toapp-btn"></div>
          <div
            v-if="item.webUrl"
            @click.stop="tolinkUrl(item.webUrl)"
            class="toweb-btn"
          ></div>
        </div>
      </div>
      <div class="title">推荐应用</div>
      <div class="app-list1">
        <div
          :class="['item', 'item' + index]"
          v-for="(item, index) in urlList1"
          :key="index"
        >
          <div class="timeConsuming">
            <span v-if="item.time == 0">检测中...</span
            ><span v-else
              ><span v-if="item.time < 50" class="green"
                >{{ item.time }}MS</span
              >
              <span v-if="item.time >= 50 && item.time < 100" class="orange"
                >{{ item.time }}MS</span
              >
              <span v-if="item.time >= 100" class="red"
                >{{ item.time }}MS</span
              ></span
            >
          </div>
          <div @click.stop="tolinkUrl(item.url)" class="toapp-btn"></div>
          <div
            v-if="item.webUrl"
            @click.stop="tolinkUrl(item.webUrl)"
            class="toweb-btn"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  name: "mobile",
  data() {
    return {
      urlList: [
        {
          time: 0,
          name: "91porn",
          url: "https://d11mj6p2thi2vw.cloudfront.net",
        },
        {
          time: 0,
          name: "逼哩逼哩",
          url: "https://d2t5w90s7u47ap.cloudfront.net",
        },
        {
          time: 0,
          name: "海角乱伦",
          url: "https://d1t1unolaftanx.cloudfront.net/",
          webUrl: "https://doyj68zud8dgm.cloudfront.net",
        },
        {
          time: 0,
          name: "69精选",
          url: "https://d2edxhak7g6q3q.cloudfront.net",
        },
        {
          time: 0,
          name: "好色",
          url: "https://d1f1wgvqrzh80g.cloudfront.net",
          webUrl: "https://d39cmeitkp3imu.cloudfront.net",
        },
        {
          time: 0,
          name: "快手视频",
          url: "https://d3av7ubft4r35p.cloudfront.net",
        },
        {
          time: 0,
          name: "91国产",
          url: "https://d3hazbgk7dtwpj.cloudfront.net",
          webUrl: "https://da8ttmrfqqhqf.cloudfront.net",
        },
        {
          time: 0,
          name: "91暗网",
          url: "https://d1h0kcl57yrnyf.cloudfront.net",
          webUrl: "https://dh0n7f6bcnjxj.cloudfront.net",
        },
      ],
      urlList1: [
        {
          time: 0,
          name: "Pomhub专业版",
          url: "https://d33dshu4o4qo3d.cloudfront.net",
        },
        {
          time: 0,
          name: "快手视频",
          url: "https://d3av7ubft4r35p.cloudfront.net",
        },
        {
          time: 0,
          name: "爆奶视频",
          url: "https://d176i026eng5sy.cloudfront.net",
        },
        { time: 0, name: "妻友", url: "https://dlk8pgalog34q.cloudfront.net" },
        {
          time: 0,
          name: "91原创",
          url: "https://d24huswlob3me8.cloudfront.net/",
        },
        {
          time: 0,
          name: "69精选",
          url: "https://d2edxhak7g6q3q.cloudfront.net",
        },
        { time: 0, name: "XV暗网", url: "https://d79yza78u30c.cloudfront.net" },
        {
          time: 0,
          name: "91Pron",
          url: "https://d11mj6p2thi2vw.cloudfront.net/",
        },
        {
          time: 0,
          name: "海角社区",
          url: "https://d1t1unolaftanx.cloudfront.net//",
        },
        {
          time: 0,
          name: "鉴黄师",
          url: "https://doua2s0i5aouj.cloudfront.net",
        },
        { time: 0, name: "18岁", url: "https://dstmsfkympgko.cloudfront.net" },
        {
          time: 0,
          name: "抖音破解版",
          url: "https://d15xo3k9plwpgm.cloudfront.net",
        },
        {
          time: 0,
          name: "两年半",
          url: "https://db5o0snppenik.cloudfront.net",
        },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }

      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        },
      );
    },
    tolinkUrl(url) {
      const routeDc = this.$route.query.dc;
      if (routeDc) {
        window.open(url + "?dc=" + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || "lqz01";
        window.open(url + "?dc=" + dc);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-page {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: url("./../../../assets/png/pcbg.webp") center;
  background-size: cover;
  .top-wrap {
    background: #1a1a1a;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
    height: 78px;
    margin-bottom: 24px;
  }
  .top {
    width: 1265px;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;

    .logo {
      width: 140px;
      height: 40px;
    }

    .cdn {
      width: 191px;
      height: 42px;
    }
  }
  .container {
    width: 1265px;
    height: 100%;
    margin: auto;
  }

  .app-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 14px;

    .item {
      width: 145px;
      height: 224px;
      cursor: pointer;
      transform: scale(1);
      transition: all 0.5s;
      position: relative;
      .toapp-btn {
        width: 55px;
        height: 24px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .toweb-btn {
        width: 40px;
        height: 24px;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }

    .item:hover {
      transform: scale(1.05);
      transition: all 0.5s;
    }

    @for $i from 0 through 7 {
      .item#{$i} {
        background: url("./../../../assets/png/pc/img/#{$i}.png");
        background-size: 100% 100%;
      }
    }
  }

  .title {
    color: #fff;
    font-size: 24px;
    font-weight: 500;
    line-height: 34px;
    margin-top: 30px;
    margin-bottom: 21px;
  }

  .app-list1 {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    gap: 14px;

    .item {
      width: 410px;
      height: 96px;
      cursor: pointer;
      transform: scale(1);
      transition: all 0.4s;
    }
    .toapp-btn {
      width: 60px;
      height: 26px;
      position: absolute;
      bottom: 35px;
      right: 9px;
    }
    .toweb-btn {
      width: 60px;
      height: 26px;
      position: absolute;
      bottom: 35px;
      right: 84px;
    }
    .item:hover {
      transform: scale(1.03);
      transition: all 0.4s;
    }

    @for $i from 0 through 12 {
      .item#{$i} {
        background: url("./../../../assets/png/pc/img1/#{$i}.png");
        background-size: 100% 100%;
      }
    }
  }
}

.timeConsuming {
  color: #31ffe4;
  font-size: 12px;
  position: absolute;
  bottom: 16px;
  left: 92px;
  width: 50px;
  background: #10121d;
}
.green {
  color: #31ffe4;
}
.orange {
  color: #f5a937;
}
.red {
  color: #e93333;
}
</style>
